export default import.meta.ROLLUP_FILE_URL_fwub4Q9$EuMDywER7wHlsg